export const SKELETOR_ENVIRONMENT = {
  BASE_URL: import.meta.env.VITE_SKELETOR_API_URL,
};

export const EMAIL_ENVIRONMENT = {
  SUPPORT_EMAIL:
    import.meta.env.VITE_SUPPORT_EMAIL || 'soporte@capitalexpress.cl',
};

export const CLIENT_PASSWORD = {
  ALGORITHM: import.meta.env.VITE_CLIENT_PASSWORD_ALGORITHM,
  ENCRYPTION_ALGORITHM: import.meta.env
    .VITE_CLIENT_PASSWORD_ENCRYPTION_ALGORITHM,
  EXPIRATION: import.meta.env.VITE_CLIENT_PASSWORD_EXPIRATION,
  ISSUER: import.meta.env.VITE_CLIENT_PASSWORD_ISSUER,
  AUDIENCE: import.meta.env.VITE_CLIENT_PASSWORD_AUDIENCE,
};

export const TOAST = {
  LIVING_TIME: Number(import.meta.env.VITE_TOASTS_LIVING_TIME),
  LIMIT: Number(import.meta.env.VITE_TOAST_LIMIT),
};

export const CHANGELOG_URL = import.meta.env.VITE_CHANGELOG_URL;

export const BUSINESS_ENVIRONMENT = {
  MAX_INVOICES_TO_SELECT: Number(import.meta.env.VITE_MAX_INVOICES_TO_SELECT),
};

export const REPORTS_API_ENVIRONMENT = {
  ENCRYPT_KEY: import.meta.env.VITE_REPORTS_ENCRYPTION_KEY,
};

export const EXCLUDED_ASSIGNEE_RUTS =
  import.meta.env.VITE_EXCLUDED_ASSIGNEE_RUTS?.split(',') ?? [];

export const ENVIRONMENT = import.meta.env.MODE;

export const TOOLS = {
  SHOW_TAILWIND_INDICATOR: import.meta.env.VITE_SHOW_TAILWIND_INDICATOR,
};

export const APPSYNC_ENVIRONMENT = {
  ENDPOINT: import.meta.env.VITE_APPSYNC_ENDPOINT,
  REGION: import.meta.env.VITE_APPSYNC_REGION,
  CHANNEL: import.meta.env.VITE_APPSYNC_CHANNEL,
};
